<template>
    <v-content>
        <v-row class="pb-0 pb-sm-10">
            <v-col class="display-1">
                {{ action === "update" ? "Редактирование настроек" : "Создание настроек" }}
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="primary" depressed @click="saveSettings()">
                        <v-icon small>mdi-plus</v-icon>
                        Сохранить
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4" class="pa-4">
                <v-row>
                    <div class="w100">
                        <p class="text-field-header">Название:</p>
                        <v-text-field
                            outlined
                            label="Название"
                            v-model="settings.name"
                        ></v-text-field>
                    </div>
                </v-row>
            </v-col>
            <v-col cols="4" class="pa-4">
                <v-row>
                    <div class="w100">
                        <p class="text-field-header">Описание:</p>
                        <v-textarea
                            outlined
                            label="Описание"
                            v-model="settings.description"
                        ></v-textarea>
                    </div>
                </v-row>
            </v-col>
            <v-col cols="4" class="pa-4">
                <v-row>
                    <div class="w100">
                        <p class="text-field-header">Название пакета:</p>
                        <v-textarea
                            outlined
                            label="Название пакета"
                            v-model="settings.app_package_name"
                        ></v-textarea>
                    </div>
                </v-row>
            </v-col>
            <v-col cols="4" class="pa-4">
                <v-row>
                    <div class="w100">
                        <p class="text-field-header">Количество сообщений после которых идет бан</p>
                        <v-text-field
                            outlined
                            label="Бан"
                            v-model="settings.settings.count_sms_ban"
                        ></v-text-field>
                    </div>
                </v-row>
            </v-col>
        </v-row>
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>Интерфейс</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="6" class="pa-6">
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Новый интерфейс?</p>
                                    <v-switch
                                        small
                                        v-model="settings.settings.interface"
                                    ></v-switch>
                                </div>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>Настройки регистрации</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="6" class="pa-6">
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Показывать слайдер?</p>
                                    <v-switch
                                        small
                                        v-model="settings.settings.show_slider"
                                    ></v-switch>
                                </div>
                            </v-row>
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Подтверждать телефон?</p>
                                    <v-switch
                                        small
                                        v-model="settings.settings.is_phone_required"
                                    ></v-switch>
                                </div>
                            </v-row>
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Подтверждать email?</p>
                                    <v-switch
                                        small
                                        v-model="settings.settings.is_email_required"
                                    ></v-switch>
                                </div>
                            </v-row>
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Mailgun впорядке?</p>
                                    <v-switch
                                        small
                                        v-model="settings.settings.is_mailgun_ok"
                                    ></v-switch>
                                </div>
                            </v-row>
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Нужен ли пароль?</p>
                                    <v-switch
                                        small
                                        v-model="settings.settings.is_password_required"
                                    ></v-switch>
                                </div>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>Агитация пользователей</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="6" class="pa-6">
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Включить агитацию?</p>
                                    <v-switch
                                        small
                                        v-model="settings.settings.agitation.is_enabled"
                                    ></v-switch>
                                </div>
                            </v-row>
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">
                                        Задержка первого уведомления после установки (в секундах):
                                    </p>
                                    <v-text-field
                                        outlined
                                        label="Задержка"
                                        type="number"
                                        step="1"
                                        v-model="settings.settings.agitation.start"
                                    ></v-text-field>
                                </div>
                            </v-row>
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">
                                        Задержка повтора уведомления после следующего открытия (в
                                        секундах):
                                    </p>
                                    <v-text-field
                                        outlined
                                        label="Задержка"
                                        type="number"
                                        step="1"
                                        v-model="settings.settings.agitation.repeat"
                                    ></v-text-field>
                                </div>
                            </v-row>
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">
                                        Офферы, которые хотим показывать:
                                    </p>
                                    <MultiplySelect
                                        :model.sync="settings.settings.agitation.offers"
                                        :options="offers"
                                        field="name"
                                        value="id"
                                        :dense="true"
                                        placeholder="Офферы"
                                    >
                                    </MultiplySelect>
                                </div>
                            </v-row>
                        </v-col>
                        <v-col cols="6" class="pa-6">
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Текст агитации:</p>
                                    <v-textarea
                                        outlined
                                        label="Текст"
                                        v-model="settings.settings.agitation.agitation_text"
                                    ></v-textarea>
                                </div>
                            </v-row>
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Текст (4+):</p>
                                    <v-textarea
                                        outlined
                                        label="Текст"
                                        v-model="settings.settings.agitation.high_text"
                                    ></v-textarea>
                                </div>
                            </v-row>
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Текст (1-3):</p>
                                    <v-textarea
                                        outlined
                                        label="Текст"
                                        v-model="settings.settings.agitation.low_text"
                                    ></v-textarea>
                                </div>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <OverlayLoader :show="isLoading"></OverlayLoader>
    </v-content>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";
import MultiplySelect from "@/app/shared/components/form-inputs/MultiplySelect";
import PostbackStatuses from "@/app/admin/postbacks/shared/services/postbackStatuses";

export default {
    name: "AdminUpdateSettings",
    components: {
        OverlayLoader,
        MultiplySelect,
    },
    data() {
        return {
            statuses: PostbackStatuses.get(),
        };
    },
    created() {
        if (this.action == "update") {
            this.$store.dispatch("GET_SETTINGS_BY_ID", this.settingsId);
        }
        this.$store.dispatch("GET_OFFERS");
    },
    computed: {
        settingsId() {
            return this.$route.params.id;
        },
        action() {
            return this.$route.name == "UpdateSettings" && this.settingsId ? "update" : "create";
        },
        settings() {
            return this.$store.getters.CURRENT_SETTINGS;
        },
        isLoading() {
            return this.$store.getters.CURRENT_SETTINGS_LOADING;
        },
        offers() {
            return this.$store.getters.OFFERS;
        },
    },
    methods: {
        saveSettings() {
            switch (this.action) {
                case "create":
                    this.$store
                        .dispatch("CREATE_SETTINGS", this.settings)
                        .then(() => {
                            this.$toast.success("Новые настройки сохранены");
                            this.$router.push({ name: "AdminSettings" });
                        })
                        .catch(() => {
                            this.$toaster.error("Неизвестная ошибка!");
                        });
                    break;
                case "update":
                    this.$store
                        .dispatch("UPDATE_SETTINGS", this.settings)
                        .then(() => {
                            this.$toast.success("Настройки изменены");
                            this.$router.push({ name: "AdminSettings" });
                        })
                        .catch(() => {
                            this.$toast.error("Неизвестная ошибка!");
                        });
            }
        },
    },
};
</script>

<style></style>
